import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid, TableHead
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Select,
    Button,
    Divider,
    Table,
    TableBody,
    MenuItem,
    TableRow,
    TextField, 
    TableCell,
    colors
} from '@material-ui/core';
import './Available_showroom.css';
import ReactHtmlParser from 'react-html-parser';
import { get_agency_showroom, get_showroom_by_agency, get_showroom_view } from '../../api/API';
import moment from 'moment/moment.js'

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

export default class Available_showrooms extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showrooms: [],
            values: {
                showroom: null,
                date: moment(new Date()).format('YYYY-MM-DD')
            },
            slots: [

            ]
        };
    }

    componentDidMount() {
        this.get_data();
    }

    async get_data() {
        console.log("GETTING DATA");
        let data = await get_agency_showroom();
        this.setState({
            ...this.state,
            showrooms: data
        }, async () => {
            this.setState({
                ...this.state,
                values: {
                    ...this.state.values,
                    showroom: data[0]['property_id']
                }
            }, async () => {
                let showroom_data = await get_showroom_by_agency(this.state.values.showroom, this.state.values.date);
                if (showroom_data) {
                    this.format_data(showroom_data);

                }
            });

        });

        return true;
    }

    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        });
        console.log("state before get", this.state);
        this.get_data();
    }

    format_data(data) {
        let current_id = window.localStorage.getItem("user_id");
        for (let i = 0; i < data.length; i++) {
            data[i]['formatted_slots'] = [];
            for (let j = 0; j < data[i].slots; j++) {
                if (j < data[i]['bookings'].length) {
                    data[i]['formatted_slots'].push({
                        booking_id: 1,
                        class: 'showroom_slot_item showroom_taken',
                        event: () => {
                            if (data[i]['bookings'][j]['agency_id'] == current_id) {
                                this.props.infoAction(
                                    data[i]['bookings'][j]['appointment_id']
                                )
                            }
                        }
                    });
                } else {
                    data[i]['formatted_slots'].push({
                        class: 'showroom_slot_item showroom_available',
                        event: () => {
                            this.props.createAction(
                                data[i]['timeslot_id'],
                                this.state.values.date,
                                data[i]['max_pax']
                            )
                        }
                    });
                }
            }
        }
        console.log(data);

        this.setState({ ...this.state, slots: data });
    }

    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardHeader title="My Showrooms">
                        <TextField />
                    </CardHeader>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <Select
                                    fullWidth
                                    name="showroom"
                                    select
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.values.showroom}
                                    variant="outlined"
                                >
                                    {this.state.showrooms.map((showroom) => (
                                        <MenuItem
                                            key={showroom.property_id}
                                            value={showroom.property_id}
                                        >
                                            {showroom.property}
                                        </MenuItem>
                                    ))}

                                </Select>
                            </Grid>

                            <Grid item md={5}>
                                <TextField
                                    fullWidth
                                    name="date"
                                    type="date"
                                    onChange={this.handleChange.bind(this)}
                                    value={this.state.values.date}

                                />
                            </Grid>

                        </Grid>
                        {this.state.slots.length ?
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Time Slots</TableCell>
                                        <TableCell>Appointments</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {this.state.slots.map(row => (
                                        <TableRow key={row.timeslot_id}>
                                            <TableCell>
                                            {moment('2020-02-02 ' + row.start_time).format("h:mm A")} - {moment('2020-02-02 ' + row.end_time).format("h:mm A")}

                                                </TableCell>
                                            <TableCell>
                                                <div className="showroom_slots" style={{
                                                    flexWrap: "wrap"
                                                }}>
                                                    {
                                                        row.formatted_slots.map(slot => (
                                                            <div

                                                                onClick={slot.event}
                                                                className={slot.class}>

                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>
                            : ""}
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

} 
